import { render, staticRenderFns } from "./LevelInfo.vue?vue&type=template&id=941fcfaa&scoped=true&"
import script from "./LevelInfo.vue?vue&type=script&lang=js&"
export * from "./LevelInfo.vue?vue&type=script&lang=js&"
import style0 from "./LevelInfo.vue?vue&type=style&index=0&id=941fcfaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "941fcfaa",
  null
  
)

export default component.exports